export const sessionStorageManager = (event: StorageEvent | null) => {
    const storageEvent = event || window.event as StorageEvent;

    if (!storageEvent?.newValue) return;

    switch (storageEvent.key) {
        case 'getSessionStorage':
            localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
            localStorage.removeItem('sessionStorage');
            break;

        case 'sessionStorage':
            const data = JSON.parse(storageEvent.newValue);
            if (data) {
                Object.entries(data).forEach(([key, value]) => {
                    sessionStorage.setItem(key, value as string);
                });
            }
            break;
    }
};